import {Link} from "react-router-dom";
import i18n from "../i18n";
import React from "react";


class ProductItemBasket extends React.Component
{
    constructor(props) {
        super(props);
    }

    render() {
        const product = this.props.product;
        return <div
            className="product"
        >
            <div
                className="image"
                style={{backgroundImage: "url('" + product.thumbnail + "')"}}
            ></div>
            <div className="info">
                <Link
                    to={`/products/${product.id}`}
                    className="name"
                >
                    <span className="fs-sm">&times;{product.quantity}</span>
                    &nbsp;
                    {i18n.get_name(product)}
                </Link>
                <span className="price">
                        <span>{product.quantity} {i18n.t("qty_metric")}</span> ({this.props.calculatePrice(product)}&nbsp;€/{i18n.t("qty_metric_single")})
                      </span>
                {
                    this.props.getPicking(product) > 0 &&
                    <span className="price">
                          {this.props.getPicking(product)}&nbsp;€ {i18n.t("picking_charge")}
                        </span>
                }
                <span className="price" style={{margin: '5px 0', fontWeight: 600}}>
                        {this.props.calculateTotalProductPrice(product)}&nbsp;€ {i18n.t("total")}
                      </span>
                <div className="controls">

                    <button
                        type="button"
                        className="btn btn-sm btn-outline"
                        onClick={() => this.props.removeProduct(product)}
                    >
                        {i18n.t('remove_product_from_basket')}
                    </button>
                </div>
            </div>
        </div>
    }
}

export default ProductItemBasket;